export default __webpack_public_path__ + "static/media/EricStage.d69c9ee6.jpg";